const initialState = {
  requestingFetchNovelties: false,
  successfulFetchNovelties: false,
  errorFetchNovelties: false,
  novelties: {},
  requestingCreateNovelty: false,
  successfulCreateNovelty: false,
  errorsCreateNovelty: false,
  novelty: null,
  requestingUpdateNovelty: false,
  successfulUpdateNovelty: false,
  errorsUpdateNovelty: false,
  rowUpdated: null,
  requestingReadNovelty: false,
  successfulReadNovelty: false,
  errorsReadNovelty: false,
  rowEdited: null,
  requestingDeleteNovelty: false,
  successfulDeleteNovelty: false,
  errorsDeleteNovelty: false,
  rowDeleted: null,
};

const noveltyReducer = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_NOVELTIES_REQUESTING":
      return {
        ...state,
        requestingFetchNovelties: true,
        successfulFetchNovelties: false,
        errorFetchNovelties: false,
      };
    case "FETCH_NOVELTIES_SUCCESS":
      return {
        ...state,
        errorFetchNovelties: false,
        requestingFetchNovelties: false,
        successfulFetchNovelties: true,
        novelties: action.value,
      };
    case "FETCH_NOVELTIES_ERROR":
      return {
        ...state,
        errorFetchNovelties: true,
        requestingFetchNovelties: false,
        successfulFetchNovelties: false,
      };
    case "FETCH_NOVELTIES_BY_STATUS_CODE_REQUESTING":
      return {
        ...state,
        requestingReadNovelty: true,
        successfulReadNovelty: false,
        errorsReadNovelty: false,
      };
    case "FETCH_NOVELTIES_BY_STATUS_CODE_SUCCESS":
      return {
        ...state,
        errorsReadNovelty: false,
        requestingReadNovelty: false,
        successfulReadNovelty: true,
        novelties: action.value,
      };
    case "FETCH_NOVELTIES_BY_STATUS_CODE_ERROR":
      return {
        ...state,
        errorsReadNovelty: true,
        requestingReadNovelty: false,
        successfulReadNovelty: false,
      };
    case "FETCH_NOVELTIES_FOR_RESCHEDULE_REQUESTING":
      return {
        ...state,
        requestingReadNovelty: true,
        successfulReadNovelty: false,
        errorsReadNovelty: false,
      };
    case "FETCH_NOVELTIES_FOR_RESCHEDULE_SUCCESS":
      return {
        ...state,
        errorsReadNovelty: false,
        requestingReadNovelty: false,
        successfulReadNovelty: true,
        novelties: action.value,
      };
    case "FETCH_NOVELTIES_FOR_RESCHEDULE_ERROR":
      return {
        ...state,
        errorsReadNovelty: true,
        requestingReadNovelty: false,
        successfulReadNovelty: false,
      };
    case "CREATE_NOVELTY_REQUESTING":
      return {
        ...state,
        requestingCreateNovelty: true,
        successfulCreateNovelty: false,
        errorsCreateNovelty: false,
      };
    case "CREATE_NOVELTY_SUCCESS":
      return {
        ...state,
        errorsCreateNovelty: false,
        requestingCreateNovelty: false,
        successfulCreateNovelty: true,
        novelty: action.value,
      };
    case "CREATE_NOVELTY_ERROR":
      return {
        ...state,
        errorsCreateNovelty: true,
        requestingCreateNovelty: false,
        successfulCreateNovelty: false,
      };
    case "UPDATE_NOVELTY_REQUESTING":
      return {
        ...state,
        requestingUpdateNovelty: true,
        successfulUpdateNovelty: false,
        errorsUpdateNovelty: false,
      };
    case "UPDATE_NOVELTY_SUCCESS":
      return {
        ...state,
        errorsUpdateNovelty: false,
        requestingUpdateNovelty: false,
        successfulUpdateNovelty: true,
        rowUpdated: action.value,
      };
    case "UPDATE_NOVELTY_ERROR":
      return {
        ...state,
        errorsUpdateNovelty: true,
        requestingUpdateNovelty: false,
        successfulUpdateNovelty: false,
      };
    case "READ_NOVELTY_REQUESTING":
      return {
        ...state,
        requestingReadNovelty: true,
        successfulReadNovelty: false,
        errorsReadNovelty: false,
      };
    case "READ_NOVELTY_SUCCESS":
      return {
        ...state,
        errorsReadNovelty: false,
        requestingReadNovelty: false,
        successfulReadNovelty: true,
        rowEdited: action.value,
      };
    case "READ_NOVELTY_ERROR":
      return {
        ...state,
        errorsReadNovelty: true,
        requestingReadNovelty: false,
        successfulReadNovelty: false,
      };
    case "CHANGE_STATE_NOVELTY_REQUESTING":
      return {
        ...state,
        requestingDeleteNovelty: true,
        successfulDeleteNovelty: false,
        errorsDeleteNovelty: false,
      };
    case "CHANGE_STATE_NOVELTY_SUCCESS":
      return {
        ...state,
        requestingDeleteNovelty: false,
        successfulDeleteNovelty: false,
        rowDeleted: action.value,
      };
    case "CHANGE_STATE_NOVELTY_ERROR":
      return {
        ...state,
        errorsDeleteNovelty: true,
        requestingDeleteNovelty: false,
        successfulDeleteNovelty: false,
      };
    case "RESET_NOVELTIES_FORM":
      return {
        ...state,
        requestingFetchNovelties: false,
        successfulFetchNovelties: false,
        errorFetchNovelties: false,
        requestingCreateNovelty: false,
        successfulCreateNovelty: false,
        errorsCreateNovelty: false,
        novelty: null,
        requestingUpdateNovelty: false,
        successfulUpdateNovelty: false,
        errorsUpdateNovelty: false,
        rowUpdated: null,
        requestingReadNovelty: false,
        successfulReadNovelty: false,
        errorsReadNovelty: false,
        rowEdited: null,
        requestingDeleteNovelty: false,
        successfulDeleteNovelty: false,
        errorsDeleteNovelty: false,
        rowDeleted: null,
      };
    case "RESET":
      return initialState;
    default:
      return state;
  }
};

export default noveltyReducer;